export default {
  your_ip_address: '현재 접속 IP입니다.',
  when_clicked_copied_to_clipboard: '클릭 시 클립보드에 복사 됩니다.',
  ok: '확인'
}
